import React, { useContext } from "react";
import { RicosContext, RicosViewerContext } from "./../../ricos-context";
import { IMAGE_TYPE } from "../types";
import { alignmentClassName, sizeClassName, textWrapClassName } from "./class-name-strategies";
import { getExpandFunction } from "./get-expand-function";
import { getImageClickActionConfig } from "./get-image-click-action-config";
import { Image } from "./image";
import { ViewerImageCaption } from "./viewer-image-caption";
const ViewerImage = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config: viewerConfig, seoMode, helpers } = useContext(RicosViewerContext);
  const { isMobile, t } = useContext(RicosContext);
  const config = viewerConfig[IMAGE_TYPE] ?? {};
  const expand = getExpandFunction({
    helpers,
    config,
    nodeId: node.id,
    imageData: node.imageData
  });
  const imageClickActionConfig = getImageClickActionConfig({
    imageData: node.imageData,
    config,
    expand
  });
  return /* @__PURE__ */ React.createElement(
    NodeViewContainer,
    {
      node,
      nodeIndex,
      customClassNames: {
        alignment: alignmentClassName(node),
        size: sizeClassName(node, isMobile),
        textWrap: textWrapClassName(node)
      }
    },
    /* @__PURE__ */ React.createElement(
      Image,
      {
        node,
        imageClickActionConfig,
        expand,
        config,
        seoMode,
        helpers,
        isMobile,
        shouldLazyLoadImages: true,
        captionComponent: /* @__PURE__ */ React.createElement(
          ViewerImageCaption,
          {
            imageType: imageClickActionConfig.type,
            caption: node?.imageData?.caption,
            defaultCaption: t("ImageViewer_Caption")
          }
        )
      }
    )
  );
};
const ImageRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ViewerImage, { key: node.id, node, ...props });
};
var viewer_image_default = ImageRenderer;
export {
  viewer_image_default as default
};
//# sourceMappingURL=viewer-image.js.map

import "@wix/ricos/css/plugin-image-viewer.global.css";